import React, { Component } from 'react'

import PropTypes from 'prop-types'
import Alert from '../../../../../Shared/Alert'
import { withTranslation } from 'react-i18next'
import Button from '../../../../../Shared/Form/Button'
import { adminPatchSalesToken } from '../../../../../../api'
import Loader from '../../../../../Shared/Loader'
import { invoiceItemTypeIds } from '../../../../../../constants'

class SalesTokensList extends Component {

  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      error: null
    }
    this.abortController = null
  }

  componentWillUnmount () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
  }

  toggleTokenActiveState = (token) => {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    this.setState({ loading: true, error: null }, () => {
      adminPatchSalesToken(token.id, { active: !token.active }, this.abortController).fetchPromise.then((response) => {
        const tokens = this.props.tokens.map((t) => {
          let newToken = Object.assign({}, t)
          if (newToken.id === response.id) {
            newToken = response
          }
          return newToken
        })
        this.props.onChange(tokens)
        this.setState({ loading: false })
      }).catch(() => {
        this.setState({ loading: false, error: 'Failed to update token' })
      })
    })
  }

  createResultRow (token) {
    const { t } = this.props
    let freeMonths = {}
    let discountCents = {}
    token.discountSettings.discounts.forEach((discount) => {
      switch (discount.type) {
        case 1:
          freeMonths[discount.fid] = discount.value
          break
        case 2:
          discountCents[discount.fid] = discount.value
          break
        default:
          throw new Error('Unexpected discount settings type ' + discount.type)
      }
    })
    return (
      <React.Fragment key={token.id}>
        <tr>
          <td data-title={t('PROMOTION_CODE')}>{token.token}</td>
          <td
            data-title={t('FREE_MONTHS') + ' ' + t('INVOICE_ITEM_ID_1')}>{freeMonths[invoiceItemTypeIds.basicFeatures] ?? 0}</td>
          <td
            data-title={t('FREE_MONTHS') + ' ' + t('INVOICE_ITEM_ID_2')}>{freeMonths[invoiceItemTypeIds.additionalFeatures] ?? 0}</td>
          <td data-title={t('DISCOUNT_SETUP_FEE')}>
            {discountCents[invoiceItemTypeIds.setupFee] === -1 ? '100%' : t('RENDER_PRICE', { value: discountCents.hasOwnProperty(invoiceItemTypeIds.setupFee) ? (discountCents[invoiceItemTypeIds.setupFee] / 100) : 0 / 100 })}</td>
          <td data-title={t('STATUS_ACTIVE')}>{token.active ? t('STATUS_ACTIVE') : t('STATUS_INACTIVE')}</td>
          <td className={'clearfix'}>
            <Button onClick={() => {this.toggleTokenActiveState(token)}}
                    classNames={'Button-Small'}
                    align={'right'}>{token.active ? t('DEACTIVATE') : t('ACTIVATE')}</Button>
          </td>
        </tr>
      </React.Fragment>
    )
  }

  render () {
    const { t } = this.props
    let tbodyContent
    if (this.props.tokens.length === 0) {
      tbodyContent = <tr>
        <td colSpan={8}>{t('NO_RESULTS')}</td>
      </tr>
    } else {
      tbodyContent = this.props.tokens.map(v => this.createResultRow(v))
    }
    return (
      <div className="flex-table" style={{ flex: 1 }}>
        <div style={{ position: 'relative' }} className="table-responsive-vertical">
          {this.state.error && <Alert type={'danger'}>{this.state.error}</Alert>}
          {this.state.loading && <Loader size={32}/>}
          <table className="table table-hover table-mc-light-blue Gradient">
            <thead>
            <tr>
              <td>{t('PROMOTION_CODE')}</td>
              <td>{t('FREE_MONTHS')} {t('INVOICE_ITEM_ID_1')}</td>
              <td>{t('FREE_MONTHS')} {t('INVOICE_ITEM_ID_2')}</td>
              <td>{t('DISCOUNT_SETUP_FEE')}</td>
              <td>{t('STATUS_ACTIVE')}</td>
              <td/>
            </tr>
            </thead>
            <tbody>
            {tbodyContent}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

SalesTokensList.propTypes = {
  tokens: PropTypes.array,
  onChange: PropTypes.func.isRequired,
}

export default withTranslation()(SalesTokensList)
